import { Form } from '@unform/web';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 0 0 0;
  width: 600px;
  align-content: center;
  align-self: center;
  button {
    margin-top: 1rem;
  }
`;

// export const Graph = styled.div`
//   height: calc(100vh - 6rem);
// `;

export const ContainerForm = styled(Form)`
  > div:not(:last-child) {
    margin-bottom: 2rem;
  }
  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }

  .section-title {
    margin-bottom: 3rem;
  }

  .print-only {
    display: none;
  }

  @media print {
    .no-print {
      display: none !important;
    }

    .print-only {
      display: block !important;
    }
  }
`;
